import { Club } from "@app/core/club/domain/model/club";

export class ClubMapper {
  static deserialize(data: any): Club {
    return new Club(
      data.id_club,
      data.name_club,
      data.city,
      data.postcode,
      data?.club_image,
      data?.address,
      data?.google_maps_link,
      data.telephone,
      data.website,
      data?.all_courts_sacra_active || false,
    );
  }
}
